export class StepTitle {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.title = options.title;
        this.id = options.titleId;
        const nameField = this.state.formFields.find(field => field.id === 'firstName');
        this.name = nameField ? nameField.value : '';
        this.$el = this.createStepTitleElement();

        this.store.subscribe(this.update.bind(this));
    }

    createStepTitleElement() { // eslint-disable-line class-methods-use-this
        const $stepTitle = document.getElementById(this.id);
        $stepTitle.innerHTML = this.title.replace(/%s/g, this.name);

        return $stepTitle;
    }

    update() {
        this.state = this.store.getState();
        const nameField = this.state.formFields.find(field => field.id === 'firstName');
        this.name = nameField ? nameField.value : '';

        this.$el.innerHTML = this.title.replace(/%s/g, this.name);
    };

    render() {
        return this.$el;
    }
}

export default StepTitle;
